import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { servicePendingDemoData } from '../../../../data/ServiceDemoData';
import LayoutProvider from '../../../Contexts/LayoutProvider';
import { useTemplate } from '../../../features/template/TemplateProvider';
import PageTitle from '../../../utils/PageTitle';
import { mkRelativeUrl } from '../../../utils/URL';
import PendingSubsPageHeader from '../../Subscriptions/SubscriptionsPending/Components/PendingSubsPageHeader';
import PendingSubsPageHeaderMobile from '../../Subscriptions/SubscriptionsPending/Components/PendingSubsPageHeaderMobile';
import ServicePendingTable from './Components/ServicePendingTable';
import ServicePendingTableMobile from './Components/ServicePendingTableMobile';
import { ApiGetPendingServices } from './ServicePendingOperation';

function ServicePendingPage() {
    // set page title
    PageTitle(`Pending Services`);

    const [servicePendingData, setServicePendingData] = useState({
        servicesList: servicePendingDemoData,
        pagination: {}
    });
    const [reloadKey, setReloadKey] = useState(0);
    const { setMessage } = useTemplate();
    const handleReload = () => {
        setReloadKey((d) => d + 1);
    };

    const navigate = useNavigate();

    // Search Params
    const [searchParams] = useSearchParams();
    const p = useMemo(
        () => ({
            'order-by': searchParams.get('order-by'),
            sort: searchParams.get('sort') || 'desc'
        }),
        [searchParams]
    );

    const handleSortingData = (column) => {
        navigate(
            mkRelativeUrl('/services/pending', {
                ...p,
                'order-by': column,
                sort: p.sort === 'desc' ? 'asc' : 'desc'
            })
        );
    };

    // -- Load pending subscriptions initially
    useEffect(() => {
        setServicePendingData({ servicesList: servicePendingDemoData, pagination: {} });
        ApiGetPendingServices()
            .then(({ data }) => {
                setServicePendingData({ servicesList: data.servicesList, pagination: {} });
            })
            .catch((err) => {
                setServicePendingData({ servicesList: [], pagination: {} });
                setMessage({ type: 'error', text: err.toString(0) });
            });
    }, [setMessage, reloadKey]);

    return (
        <div className="subscriptions_pending_page inner_page_cont">
            <LayoutProvider>
                <PendingSubsPageHeader handleReload={handleReload} layout="default" />
                <PendingSubsPageHeaderMobile
                    handleReload={handleReload}
                    layout={['md', 'sm', 'xs', 'xxs']}
                />
            </LayoutProvider>
            <LayoutProvider>
                <ServicePendingTable
                    data={servicePendingData}
                    handleReload={handleReload}
                    sortBy={p.sort}
                    sortedColumn={p['order-by']}
                    sortedHandler={handleSortingData}
                    layout="default"
                />
                <ServicePendingTableMobile
                    data={servicePendingData}
                    layout={['md', 'sm', 'xs', 'xxs']}
                />
            </LayoutProvider>
        </div>
    );
}
export default ServicePendingPage;
